import { useTranslation } from "react-i18next";
import { handleFormChange } from "../../../../components/modals/EditableTable";
import WasteFlowFormPanel from "../WasteFlowFormPanel";
import {
  WASTE_FORM_INPUT_CLASS,
  WASTE_FORM_LABEL_CLASS,
} from "../wasteFlowFormUi";

const WasteFlowCostsTab = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  return (
    <WasteFlowFormPanel title={t("Treatment cost")}>
      <div className="waste-flow-form-field">
        <label
          className={WASTE_FORM_LABEL_CLASS}
          htmlFor="waste-flow-treatment-cost"
        >
          {t("Treatment cost")}
        </label>
        <div className="relative">
          <input
            id="waste-flow-treatment-cost"
            type="number"
            name="treatmentCostFull"
            className={`${WASTE_FORM_INPUT_CLASS} pr-20`}
            value={formData.treatmentCostFull ?? ""}
            min={0}
            placeholder="0"
            onChange={(e) => handleFormChange(e, formData, setFormData)}
          />
          <span className="waste-flow-field-suffix" aria-hidden>
            {`€ / ${t("settingsWaste.treatmentCostPerTon")}`}
          </span>
        </div>
      </div>
    </WasteFlowFormPanel>
  );
};

export default WasteFlowCostsTab;
